export default __webpack_public_path__ + "static/media/screen1.2bb3cf5d.png";